// extracted by mini-css-extract-plugin
module.exports = {"container":"JoinOurCommunitySection_container__FMgpb","title":"JoinOurCommunitySection_title__oDvXT","text":"JoinOurCommunitySection_text__mHxN3"};